// extracted by mini-css-extract-plugin
export default {"container":"SubsidiaryDocuments_container__TTZnX","dropdown":"SubsidiaryDocuments_dropdown__x3Apa","uploadFormHolder":"SubsidiaryDocuments_uploadFormHolder__Hx7h3"};